<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

        <config-title-hang>
          <span slot="config_title_hang_ele2">所有的控制对象</span>
          <input slot="config_title_hang_ele8" type="text" placeholder="快速搜索" v-model="scerchValue" />
        </config-title-hang>

        <!-- 服务器返回的根据按键控制类型返回的设备列表 -->
        <config-hang
          v-for="(value, index) in serveControlObjectListData"
          :key="index"
          @click.native.stop="selectObjectBtnHandle(value)"
          :selectState1="
            value.businessId === selectObjectInfo.businessId1 ||
              value.businessId === selectObjectInfo.businessId2
          "
          :switchState="value.businessState"
        >
          <!-- 选中和未选中状态图片 -->
          <img
            v-if="
              value.businessId === selectObjectInfo.businessId1 ||
                value.businessId === selectObjectInfo.businessId2
            "
            slot="config_hang_ele1"
            src="~assets/img/config/xuanzhong.png"
            alt
          />
          <img v-else slot="config_hang_ele1" src="~assets/img/config/weixuan.png" alt />

          <span slot="config_hang_ele2">{{ value.businessName }}（{{ value.regionName }}）</span>

          <!-- 设备状态百分比的显示，同时对条件进行判断，只有调光类的显示，不绑定任何设备不显示 -->
          <span
            v-if="
              value.businessId != '0' && ServeOneObjectinfo.buttonCode === '4'
            "
            slot="config_hang_ele3_state_text"
            @click="stateConfigBtnHandle(value)"
          >{{ value.businessState }}%</span>
          <!-- 设备状态图片 不绑定任何设备时不显示 只有通断和调光类的设备需要展示 -->
          <img
            v-if="
              value.businessId != '0' &&
                (ServeOneObjectinfo.buttonCode === '3' ||
                  ServeOneObjectinfo.buttonCode === '4')
            "
            slot="config_hang_switchBtn_open"
            src="~assets/img/config/zhu_kai.png"
            alt
            @click="stateConfigBtnHandle(value)"
          />
          <img
            v-if="
              value.businessId != '0' &&
                (ServeOneObjectinfo.buttonCode === '3' ||
                  ServeOneObjectinfo.buttonCode === '4')
            "
            slot="config_hang_switchBtn_close"
            src="~assets/img/config/zhu_guan.png"
            alt
            @click="stateConfigBtnHandle(value)"
          />
        </config-hang>

        <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">保存并返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
import configHang from "components/common/config/config-hang";

import configTitleHang from "components/common/config/config-title-hang";
import { mediumslateblue } from "color-name";

export default {
  data() {
    return {
      serveControlObjectListData: [
        ///服务器返回的控制设备数据
      ],
      serveControlObjectListDataBack: [
        //搜索使用
      ],
      scerchValue: "", // 搜索使用
      ServeOneObjectinfo: {
        ////一个对象的信息
      },
      selectButton: {
        buttonCode: "",
        buttonId: "",
        buttonName: "",
      }, ////选中的ID
      noBusinessInfo: {
        ////虚拟的一个不绑定任何对象的可选信息
        businessId: "0",
        businessName: "不绑定任何对象",
        businessState: 0,
        regionId: "",
        regionName: "无",
      },
      selectObjectInfo: {
        ////已经选中的绑定信息
        businessId1: "",
        businessId1Desc: "",
        businessState1: 0,
        businessId2: "",
        businessId2Desc: "",
        businessState2: 0,
      },
    };
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang,
  },
  methods: {
    stateConfigBtnHandle(value) {
      console.log("状态设置按钮被点了");

      if (this.ServeOneObjectinfo.buttonCode === "3") {
        ///说明是通断设备
        if (value.businessState === 0) {
          value.businessState = 1;
        } else {
          value.businessState = 0;
        }
        if (this.$route.query.type === 1) {
          ////有人时选择设备
          this.selectObjectInfo.businessId1 = value.businessId;
          this.selectObjectInfo.businessId1Desc = value.businessName;
          this.selectObjectInfo.businessState1 = value.businessState;
        } else if (this.$route.query.type === 2) {
          ///无人时选择设备
          this.selectObjectInfo.businessId2 = value.businessId;
          this.selectObjectInfo.businessId2Desc = value.businessName;
          this.selectObjectInfo.businessState2 = value.businessState;
        }
      } else if (this.ServeOneObjectinfo.buttonCode === "4") {
        let oneObjectConfig = {
          deviceId: "406476629855047680",
          openState: value.businessState,
          openStateValue: value.businessState,
          openStateValue1: 1,
          openStateValue2: 1,
          passwordState: 0,
          productCode: "02", ///代表是调光设备
          regionName: this.ServeOneObjectinfo.regionName,
          remark: value.businessName,
          value: value, ////带参进去处理
          selectObjectInfo: this.selectObjectInfo, ////带参进去处理
          type: this.$route.query.type, ////带参进去处理
        };
        ////调光类设备  带参数进到页面去处理
        this.$showControlToast("paraconfig", oneObjectConfig);
        // this.selectObjectBtnHandle(value)
      }
    },
    selectObjectBtnHandle(value) {
      console.log("111111");
      // 触发类型	BUTTON_01("1", "单场景"), BUTTON_02("2", "双场景"),  	BUTTON_03("3", "通断"), BUTTON_04("4", "调光"),  	BUTTON_05("5", "电机")
      console.log(value);
      if (this.$route.query.type === 1) {
        ////有人时选择设备
        this.selectObjectInfo.businessId1 = value.businessId;
        this.selectObjectInfo.businessId1Desc = value.businessName;
        this.selectObjectInfo.businessState1 = value.businessState;
      } else if (this.$route.query.type === 2) {
        ///无人时选择设备
        this.selectObjectInfo.businessId2 = value.businessId;
        this.selectObjectInfo.businessId2Desc = value.businessName;
        this.selectObjectInfo.businessState2 = value.businessState;
      }

      // if (this.ServeOneObjectinfo.buttonCode === '2') {
      //   ///说明是双场景,最多选两个  这一块牵扯的逻辑较多，不宜修改
      //   console.log('2222')
      //   if (value.businessId === '0') {
      //     if (
      //       this.selectObjectInfo.businessId1 === '0' ||
      //       this.selectObjectInfo.businessId2 === '0'
      //     ) {
      //       this.selectObjectInfo.businessId2 = ''
      //       this.selectObjectInfo.businessId1 = ''
      //     } else {
      //       this.selectObjectInfo.businessId2 = value.businessId
      //       this.selectObjectInfo.businessId1 = value.businessId
      //     }
      //     this.selectObjectInfo.businessId1Desc = value.businessName
      //     this.selectObjectInfo.businessId2Desc = ''
      //     console.log(this.selectObjectInfo.businessId1)
      //     console.log(this.selectObjectInfo.businessId2)
      //     return
      //   }
      //   if (
      //     this.selectObjectInfo.businessId1 === value.businessId ||
      //     this.selectObjectInfo.businessId2 === value.businessId
      //   ) {
      //     if (this.selectObjectInfo.businessId1 === value.businessId) {
      //       this.selectObjectInfo.businessId1 = ''
      //       this.selectObjectInfo.businessId1Desc = ''
      //       // this.selectObjectInfo.businessId2Desc = value.businessName
      //     } else if (this.selectObjectInfo.businessId2 === value.businessId) {
      //       this.selectObjectInfo.businessId2 = ''
      //       this.selectObjectInfo.businessId2Desc = ''
      //     }
      //     console.log(this.selectObjectInfo.businessId1)
      //     console.log(this.selectObjectInfo.businessId2)
      //     return
      //   }
      //   if (value.businessId != '0') {
      //     if (
      //       this.selectObjectInfo.businessId1 === '' ||
      //       this.selectObjectInfo.businessId2 === ''
      //     ) {
      //       if (this.selectObjectInfo.businessId1 === '') {
      //         this.selectObjectInfo.businessId1 = value.businessId
      //         this.selectObjectInfo.businessId1Desc = value.businessName
      //         // this.selectObjectInfo.businessId2Desc = value.businessName
      //       } else if (this.selectObjectInfo.businessId2 === '') {
      //         this.selectObjectInfo.businessId2 = value.businessId
      //         // this.selectObjectInfo.businessId1Desc = value.businessName
      //         this.selectObjectInfo.businessId2Desc = value.businessName
      //       }
      //     } else if (
      //       this.selectObjectInfo.businessId1 != '' ||
      //       this.selectObjectInfo.businessId2 != ''
      //     ) {
      //       if (
      //         this.selectObjectInfo.businessId1 === '0' ||
      //         this.selectObjectInfo.businessId2 === '0'
      //       ) {
      //         this.selectObjectInfo.businessId1 = value.businessId
      //         this.selectObjectInfo.businessId1Desc = value.businessName
      //         this.selectObjectInfo.businessId2 = ''
      //         this.selectObjectInfo.businessId2Desc = ''

      //         // if (this.selectObjectInfo.businessId1 === '0') {
      //         //   this.selectObjectInfo.businessId1 = value.businessId
      //         //   this.selectObjectInfo.businessId2 = ''
      //         // } else if (this.selectObjectInfo.businessId2 === '0') {
      //         //   this.selectObjectInfo.businessId2 = value.businessId
      //         //   this.selectObjectInfo.businessId1 = ''
      //         // }
      //       } else {
      //         this.selectObjectInfo.businessId2 = value.businessId
      //         this.selectObjectInfo.businessId2Desc = value.businessName
      //       }
      //       // if (this.selectObjectInfo.businessId1 === '') {
      //       //   this.selectObjectInfo.businessId1 = value.businessId
      //       // } else if (this.selectObjectInfo.businessId2 === '') {
      //       //   this.selectObjectInfo.businessId2 = value.businessId
      //       // }
      //     }
      //   }
      // } else if (
      //   this.ServeOneObjectinfo.buttonCode === '3' ||
      //   this.ServeOneObjectinfo.buttonCode === '4'
      // ) {
      //   if (this.$route.query.type === 1) {
      //     ////有人时选择设备
      //     this.selectObjectInfo.businessId1 = value.businessId
      //     this.selectObjectInfo.businessId1Desc = value.businessName
      //     this.selectObjectInfo.businessState1 = value.businessState
      //   } else if (this.$route.query.type === 2) {
      //     ///无人时选择设备
      //     this.selectObjectInfo.businessId2 = value.businessId
      //     this.selectObjectInfo.businessId2Desc = value.businessName
      //     this.selectObjectInfo.businessState2 = value.businessState
      //   }
      // }
      console.log(this.selectObjectInfo.businessId1);
      console.log(this.selectObjectInfo.businessId2);

      // this.selectButton.buttonId = value.buttonId
      // this.selectButton.buttonCode = value.buttonCode
      // this.selectButton.buttonName = value.buttonName
    },
    saveReturnBtnHandle() {
      ///保存并返回按钮点击了
      if (this.$route.query.type === 1) {
        if (this.selectObjectInfo.businessId1 === "") {
          this.$toast("请至少选择一个控制对象！");
          return;
        }
      } else if (this.$route.query.type === 2) {
        if (this.selectObjectInfo.businessId2 === "") {
          this.$toast("请至少选择一个控制对象！");
          return;
        }
      }
      // if (this.ServeOneObjectinfo.buttonCode === '2') {
      //   //说明是场景 在感应器类型里面选择一个就行了
      //   console.log(this.ServeOneObjectinfo.buttonCode)
      //   if (
      //     this.selectObjectInfo.businessId1 === '' ||
      //     this.selectObjectInfo.businessId2 === ''
      //   ) {
      //     this.$toast('请至少选择两个场景或选择不绑定！')
      //     return
      //   }
      // } else {

      // }
      console.log(this.selectObjectInfo);
      ////提交选中的信息并返回
      if (this.$route.query.type === 1) {
        ////有人时提交
        this.ServeOneObjectinfo.businessId1 = this.selectObjectInfo.businessId1;
        this.ServeOneObjectinfo.businessId1Desc = this.selectObjectInfo.businessId1Desc;
        // if(this.selectObjectInfo.businessId1 === )
        this.ServeOneObjectinfo.businessState1 = this.selectObjectInfo.businessState1;
      } else if (this.$route.query.type === 2) {
        this.ServeOneObjectinfo.businessId2 = this.selectObjectInfo.businessId2;
        this.ServeOneObjectinfo.businessId2Desc = this.selectObjectInfo.businessId2Desc;
        this.ServeOneObjectinfo.businessState2 = this.selectObjectInfo.businessState2;
      }
      // this.ServeOneObjectinfo.buttonName = this.selectButton.buttonName
      this.$router.go(-1);
    },
    selectDeviceStateHandle(listData) {
      ////对服务端传来的状态列表进行判断和处理，对选中的设备状态进行更新
      for (let i = 0; i < listData.length; i++) {
        if (this.$route.query.type === 1) {
          // console.log(listData[i].businessId)
          // console.log(this.ServeOneObjectinfo.businessId1)

          if (listData[i].businessId === this.selectObjectInfo.businessId1) {
            // console.log(this.selectObjectInfo.businessState1)
            listData[i].businessState = this.selectObjectInfo.businessState1;
            return;
          }
        } else if (this.$route.query.type === 2) {
          if (listData[i].businessId === this.selectObjectInfo.businessId2) {
            listData[i].businessState = this.selectObjectInfo.businessState2;
            return;
          }
        }
        // const element = listData[i];
      }
    },
    //业内数据搜索显示  //搜索使用
    seraceDataShow(charData) {
      if (
        this.serveControlObjectListData &&
        this.serveControlObjectListDataBack
      ) {
        //数据是合法存在的
        this.serveControlObjectListData = this.serveControlObjectListData.concat(
          this.serveControlObjectListDataBack
        );
        this.serveControlObjectListDataBack.length = 0;
        if (charData.match(/^[ ]*$/)) {
          //说明为空 或多个空
        } else {
          let dataLength = this.serveControlObjectListData.length;
          for (let i = 0; i < dataLength; i++) {
            if (
              (
                this.serveControlObjectListData[i].businessName +
                this.serveControlObjectListData[i].regionName
              ).indexOf(charData) == -1
            ) {
              // && this.serveControlObjectListData[i].checked == false
              // 说明没有这个字符
              this.serveControlObjectListDataBack.push(
                this.serveControlObjectListData[i]
              );
              this.serveControlObjectListData.splice(i, 1);
              dataLength--;
              i--;
            }
          }
        }
        console.log(this.serveControlObjectListData);
      }
    }
  },
  watch: {
    scerchValue: function (val) {
      console.log("发生变化" + val);
      this.seraceDataShow(val); //新增页内搜索
    },
  },
  created() {
    console.log("created阶段");
    this.ServeOneObjectinfo = this.$store.state.configinfo.ServeOneObjectinfo; ////一个对象的地址信息拿过来

    ////拿到选中的信息  判断进入类型
    if (this.$route.query.type === 1) {
      this.selectObjectInfo.businessId1 = this.ServeOneObjectinfo.businessId1;
      this.selectObjectInfo.businessId1Desc = this.ServeOneObjectinfo.businessId1Desc;
      this.selectObjectInfo.businessState1 = this.ServeOneObjectinfo.businessState1;
    } else if (this.$route.query.type === 2) {
      this.selectObjectInfo.businessId2 = this.ServeOneObjectinfo.businessId2;
      this.selectObjectInfo.businessId2Desc = this.ServeOneObjectinfo.businessId2Desc;
      this.selectObjectInfo.businessState2 = this.ServeOneObjectinfo.businessState2;
    }

    ///获取触发设备接口，获取数据
    this.$request({
      method: "post",
      url: "/device/findTriggerDeviceByButtonCode",
      data: {
        token: this.$store.state.token,
        buttonCode: this.ServeOneObjectinfo.buttonCode,
        gatewayId: this.ServeOneObjectinfo.gatewayId,
      },
    })
      .then((res) => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message);
          ////说明信息填写错误,控制失败了，
          return;
        } else {
          ////、控制成功了
          this.serveControlObjectListData = res.data.data; ////拿到服务器返回的数据结果
          this.serveControlObjectListData.unshift(this.noBusinessInfo); ///添加一个不绑定任何设备的可选对象信息
          this.selectDeviceStateHandle(this.serveControlObjectListData); ////更新选中设备的状态
          console.log(this.serveControlObjectListData);
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch((error) => {
        console.log(error);
      });

    ////拿到已经选中的信息
    // this.selectButton.buttonCode = this.ServeOneObjectinfo.buttonCode
    // this.selectButton.buttonId = this.ServeOneObjectinfo.buttonId
    // this.selectButton.buttonName = this.ServeOneObjectinfo.buttonName
  },
};
</script>

<style></style>
